"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutRunnerProvider = exports.IntervalRunnerProvider = exports.BaseRunner = void 0;
var _kernel_container_1 = __importDefault(require("../../../container"));
var BaseRunner = (function () {
    function BaseRunner(targetInterval, runTasksCallback, statLimit, logger) {
        this.targetInterval = targetInterval;
        this.runTasksCallback = runTasksCallback;
        this.statLimit = statLimit;
        this.logger = logger;
        this.intervalRunStats = [];
        this.started = false;
    }
    BaseRunner.prototype.runTick = function () {
        this.runTasksCallback();
        this.updateStats();
    };
    BaseRunner.prototype.setDoneCallback = function (cb) {
        this.doneCallback = cb;
    };
    BaseRunner.prototype.getStats = function () {
        return {
            lastRun: this.lastRun,
            lastActualInterval: this.lastActualInterval,
            intervalStats: this.intervalRunStats,
            intervalValid: this.checkIntervalValidity(),
        };
    };
    BaseRunner.prototype.updateStats = function () {
        var now = Date.now();
        if (this.lastRun) {
            this.lastActualInterval = now - this.lastRun;
            this.intervalRunStats.push(this.lastActualInterval);
            if (this.intervalRunStats.length > this.statLimit) {
                this.intervalRunStats = this.intervalRunStats.slice(1, this.intervalRunStats.length);
            }
        }
        this.lastRun = now;
    };
    BaseRunner.prototype.checkIntervalValidity = function () {
        var now = Date.now();
        if (this.lastRun) {
            var currentInterval = now - this.lastRun;
            if (currentInterval < this.targetInterval * 2) {
                return true;
            }
        }
        return false;
    };
    BaseRunner.prototype.start = function () {
        throw new Error("Not implemented");
    };
    BaseRunner.prototype.stop = function () {
        throw new Error("Not implemented");
    };
    return BaseRunner;
}());
exports.BaseRunner = BaseRunner;
var IntervalRunnerProvider = (function (_super) {
    __extends(IntervalRunnerProvider, _super);
    function IntervalRunnerProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntervalRunnerProvider.prototype.start = function () {
        var _this = this;
        if (this.timeout)
            throw new Error("Scheduler already started");
        this.started = true;
        var timer = _kernel_container_1.default.get("TIMER");
        this.timeout = timer.setInterval(function () {
            var _a;
            try {
                _this.runTick();
            }
            catch (e) {
                (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.warn("Unable to run scheduled tasks with error: ".concat(e.toString()));
            }
        }, this.targetInterval);
    };
    IntervalRunnerProvider.prototype.stop = function () {
        var _a;
        var timer = _kernel_container_1.default.get("TIMER");
        this.timeout && timer.clearInterval(this.timeout);
        (_a = this.doneCallback) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    return IntervalRunnerProvider;
}(BaseRunner));
exports.IntervalRunnerProvider = IntervalRunnerProvider;
var TimeoutRunnerProvider = (function (_super) {
    __extends(TimeoutRunnerProvider, _super);
    function TimeoutRunnerProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeoutRunnerProvider.prototype.start = function () {
        if (this.timeout)
            throw new Error("Scheduler already started");
        this.started = true;
        this.reschedule();
    };
    TimeoutRunnerProvider.prototype.stop = function () {
        var _a;
        var timer = _kernel_container_1.default.get("TIMER");
        this.timeout && timer.clearTimeout(this.timeout);
        (_a = this.doneCallback) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    TimeoutRunnerProvider.prototype.reschedule = function () {
        var _this = this;
        var timer = _kernel_container_1.default.get("TIMER");
        this.timeout && timer.clearTimeout(this.timeout);
        this.timeout = timer.setTimeout(function () {
            var _a;
            try {
                _this.runTick();
            }
            catch (e) {
                (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.warn("Unable to run scheduled tasks with error: ".concat(e.toString()));
            }
            finally {
                _this.reschedule();
            }
        }, this.targetInterval);
    };
    return TimeoutRunnerProvider;
}(BaseRunner));
exports.TimeoutRunnerProvider = TimeoutRunnerProvider;
//# sourceMappingURL=index.js.map